var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: {
        title: _vm.form.id ? "修改" : "新增",
        visible: _vm.dialogShow,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "110px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "名称", prop: "name" } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入名称" },
                model: {
                  value: _vm.form.name,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "语言", prop: "language" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.language,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "language", $$v)
                    },
                    expression: "form.language"
                  }
                },
                _vm._l(_vm.language, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "状态", prop: "is_open" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.is_open,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "is_open", $$v)
                    },
                    expression: "form.is_open"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1, border: "" } }, [
                    _vm._v("已开放")
                  ]),
                  _c("el-radio", { attrs: { label: 0, border: "" } }, [
                    _vm._v("未开放")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: { label: "跳转链接", prop: "url" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入跳转链接" },
                model: {
                  value: _vm.form.url,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "url", $$v)
                  },
                  expression: "form.url"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "100%" },
              attrs: { label: "图片", prop: "img" }
            },
            [
              _c("uploadImage", {
                attrs: { value: _vm.fileList },
                on: { input: _vm.imgChange }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.hide()
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: {
                click: function($event) {
                  return _vm.clearData(true)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitData()
                }
              }
            },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }